
import React, { useEffect,  useState } from "react";

import { AudioWaveform, Blocks, ChevronDown, ChevronUp, Fan, Info, Video } from "lucide-react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import PlayerPageCardFolderContents from "./PlayerPageCardFoldersContents";
import { getContentsClientByChapter } from "../../store/actions/CreateCourse/CourseApi";

const PlayerPageChapterCard =({courseId,playerCard1Object,setCurrentItem,contentItem})=>{
  
               const [openContent, setOpenContent] = useState(true);
      const [itemArr, setItemArr] = useState([]);
                     const [counts, setCounts] = useState({});
                     
                     const [openFolder, setOpenFolder] = useState(true);
                     
                             const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
                     
            const [sort, setSort] = useState("ASC");
                     const [pageNo, setPageNo] = useState(1);
                     const [limit, setLimit] = useState(10);
                   const [dropDownVal, setDropDownVal] = useState("Active");
                      const [startDate, setStartDate] = useState(null);
                
                  const [endDate, setEndDate] = useState(null);
            const [advancedFilters , setAdvancedFilters] =useState(true)
               const [toggleStatePaid , setToggleStatePaid] =useState(null)
               const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
             
             const dispatch = useDispatch();
                      const user = useSelector((state)=>state?.user?.user);
                           
                      const [snackbarVisible, setSnackbarVisible] = useState(false);
                                       const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                       const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                                 
                                        
                                    const showSnackbar = () => {
                                      setSnackbarVisible(true);
                                    };
                                   
                                    const hideSnackbar = () => {
                                      setSnackbarVisible(false);
                                    };
                              
                              
                                         
                                         
                                      
                                     const [animate, setAnimate] = useState(false);
                       
                        const [loader , setLoader] =useState({status:true});
               
                   
                          const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                          const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                         );
                         
                             const userData =useSelector((state)=>state?.user?.user);
                            const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                            const appId = useSelector((state)=>state?.user?.user?.appId);
                          
                                    
                 
               const fireGetContentsClientByChapter=()=>{
                      setItemArr([])
                       
                   
                     setItemArrLoading([{},{},{},{}])
                     setLoader({status:true});
                           const apiData = dispatch(getContentsClientByChapter({userEmail:userEmail?userEmail:"",
                  currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,postParent:contentItem?.ID}));
                           /* get response as Promise   */
                           apiData.then(response => {
                           console.log(response)
                     
                             if(response?.contents){
                             setItemArr(response?.contents);
                     setItemArrLoading([])
                             setResponseMessage(response?.message);
                             setSnackbarColor("rgba(144, 202, 249,1)");
                           
                         setLoader({status:false});
                         
                         // setSnackbarVisible(true);
                         setTimeout(()=>{
                           
                           setSnackbarVisible(false);
                         },1000)
                         
                               
                             
                            if(response?.logout){
                            
                             setResponseMessage("You are Logged Out!!!");
                               
                             setSnackbarColor("#958FDA");
                           
                             
                              
                         setLoader({status:false});
                         
                         setSnackbarVisible(true);
                         setTimeout(()=>{
                           
                           setSnackbarVisible(false);
                          
                            
                         },3000)
                             setTimeout(()=>{
                               dispatch({type:"LOGOUT"});
                         
                             },3000)
                             
                           }
                         
                             }else{
                               setResponseMessage("Something Went Wrong...");
                               
                               setSnackbarColor("#958FDA");
                             
                                
                           setLoader({status:false});
                           
                           setSnackbarVisible(true);
                           setTimeout(()=>{
                             
                             setSnackbarVisible(false);
                            
                              
                           },3000)    }
                         
                           }).catch(error => {
                          
                             //popup of error Info
                             setResponseMessage("Something Went Wrong...");
                               
                             setSnackbarColor("#958FDA");
                          
                             
                              
                         setLoader({status:false});
                         
                         setSnackbarVisible(true);
                         setTimeout(()=>{
                           
                           setSnackbarVisible(false);
                          
                            
                         },3000)
                            
                           });
                      }
             
           
           useEffect(()=>{fireGetContentsClientByChapter()},[])
             const flattenedData = itemArr!=[]?Object.values(itemArr):'';
           
                    const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
            
                              
    return(<> {
    <div className="sidebarCardChapter" >
    <div className="sidebarCardSectionInner" ><div>
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <AudioWaveform size={26} color={playerCard1Object?.chapter?.textColor?.color} />
    <div className="player-cardTitleFont" style={{fontSize:"14px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>{playerCard1Object?.chapter?.title}</div>
    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px",margin:"7px"}}>
    
   {contentItem?.counts?.folders?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>{contentItem?.counts?.folders} Folders</span>:""}
    {contentItem?.counts?.videos?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>{contentItem?.counts?.videos} Videos</span>:""}
    {contentItem?.counts?.quizzes?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>{contentItem?.counts?.quizzes} Quizzes</span>:""}
   </div> 
    </div>
    {openContent?<div onClick={()=>{setOpenContent(false)}} style={{background:`${playerCard1Object?.chapter?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}}  ><ChevronUp size={22}  color={playerCard1Object?.chapter?.iconColor?.color}/></div> 
:<div onClick={()=>{setOpenContent(true)}} style={{background:`${playerCard1Object?.chapter?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}}  ><ChevronDown size={22}  color={playerCard1Object?.chapter?.iconColor?.color}/></div> 
 }

</div>
    {openContent?flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div key={index} style={{background:`${playerCard1Object?.chapter?.bgColor?.color}`,
border:` ${playerCard1Object?.chapter?.border?.borderWidth?.value+playerCard1Object?.chapter?.border?.borderWidth?.resolution} ${playerCard1Object?.chapter?.border?.borderType}  ${playerCard1Object?.chapter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.topLeft?.value}${playerCard1Object?.chapter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.chapter?.borderRadius?.topRight?.value}${playerCard1Object?.chapter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.value}${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomRight?.value}${playerCard1Object?.chapter?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px",padding:"5px",marginTop:"10px"}}>
    {item?.postType=="folder"?<div>
<PlayerPageCardFolderContents courseId={courseId} playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}}folderItem={item} />
   </div>:""}</div>)):"":"":""}
{
  // lesson Card
}


   </div>}
    </>)
}
export default PlayerPageChapterCard

